export { ScrollCards, ScrollCardColor } from "./ScrollCards";
export type { ScrollCardsProps, ScrollCardItem, ScrollCardColorType } from "./ScrollCards";
